import { useRef } from 'react';
import {
  BetterGuardClient,
  ServiceName,
  jwtTokenFromLocalStorage,
  setBetterGuardGlobalLogger,
} from '@amzn/acs-better-guard-common';
import { envVariables } from 'src/resources/envVariables';

export const useDeviceRenameBetterGuardClient =
  (): BetterGuardClient | null => {
    const clientRef = useRef<BetterGuardClient | null>(null);

    if (!clientRef.current && envVariables.stage) {
      clientRef.current = new BetterGuardClient(
        ServiceName.DeviceRename,
        jwtTokenFromLocalStorage(envVariables.userPoolClientId),
        {
          stage: envVariables.stage === 'prod' ? 'prod' : 'gamma',
        }
      );
      // eslint-disable-next-line no-console
      setBetterGuardGlobalLogger(console.log);
    }

    return clientRef.current;
  };
